import styled from 'styled-components'

export const Title = styled.label`
    padding-top: 15px;
    padding-bottom: 15px;
    /* padding-left: 15px; */
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: var(--gray-800);
`

export const Label = styled.label`
    font-size: 11px;
    text-transform: capitalize;
    font-weight: 600;
    line-height: 16px;
    color: var(--gray-700);
    overflow-wrap: break-word;
    cursor: pointer;
    :hover {
        text-decoration: underline;
        text-decoration-thickness: 2px;
    }
`

export const Actions = styled.section`
    display: flex;
    justify-content: space-around;
    width: 96px;
`

export const Header = styled.div`
    width: 100%;
    min-width: 940px;
    display: flex;
    position: relative;
    flex-direction: row;
    > section label {
        font-family: ${({ theme }) => theme['font-bold']};
        font-size: 12px;
        line-height: 16px;
    }
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 5px;
    /* &:hover {
        ${Actions} {
            display: flex;
        }
    } */
`

export const ReportName = styled.section`
    display: flex;
    flex-grow: 3;
    align-items: center;
    width: 25%;
    overflow-wrap: break-word;
    line-height: 16px;
`

export const Author = styled.section`
    flex-grow: 2;
    width: 10%;
    overflow-wrap: break-word;
    line-height: 16px;
`

export const ReportStatus = styled.section`
    width: 144px;
`

export const EditStatus = styled.section`
    width: 152px;
`

export const LastExecution = styled.section`
    flex-grow: 1;
    overflow-wrap: break-word;
    width: 20%;
`

export const StyledSearchAndFilter = styled.div`
    height: 40px;
    display: flex;
    gap: 8px;
    margin-bottom: 32px;
    
    .report-create-button {
        width: 148px;
        .btn-report-create-button {
            border-radius: 4px;
            :hover {
                background-color: ${({ theme }) => theme['blue-700']};
            }
            width: 100%;
            height: 40px;
            
            .btn-report-create-button-content {
                margin-top: 5px; //TODO SOLVE IT LATER
                font-family: ${({ theme }) => theme['font-semibold'] || 'SourceSansPro-Semibold'};
                font-size: 15px;
                line-height: 16px;

                i {
                    margin-right: 8px;
                    /* font-family: ${({ theme }) => theme['font-regular'] || 'Font Awesome 5 Pro Regular'}; */
                    font-size: 13px;
                    line-height: 16px;
                }
            }
        }
    }
    .report-search {
        flex-grow: 1;
        input {
            height: 38px;
        }
    }

    .report-filter-selector {
        width: 107px;
        heght: 40px;

        //TODO REFACTOR THIS MESS
        border-radius: 4px;
        border: ${({ theme }) => "1px solid " + theme['blue-400']};
        background-color: ${({ theme }) => theme['gray-0']};
        cursor: pointer;
        :hover {
            border: ${({ theme }) => "1px solid " + theme['blue-500']};
            .report-filter-button-dropdown-icon, .report-filter-button-dropdown-label{ 
                color: ${({ theme }) => theme['blue-700']};
                cursor: pointer;
            }
        }
        
        .report-filter-button-dropdown-icon, .report-filter-button-dropdown-label{
            color: ${({ theme }) => theme['blue-500']};
        }

        .dropdown {
            width: 100%;
            height: 100%;

            .report-filter-button-dropdown-content {
                display: flex;
                width: 100%;
                height: 100%;

                justify-content: center;
                gap: 8px;
                align-items: center;
                border-radius: 4px;

                .report-filter-button-dropdown-icon {
                    /* font-family: ${({ theme }) => theme['font-regular'] || 'Font Awesome 5 Pro Regular'}; */
                    font-size: 13px;
                    line-height: 16px;
                }
                .report-filter-button-dropdown-label {
                    font-family: ${({ theme }) => theme['font-semibold'] || 'SourceSansPro-Semibold'};
                    font-size: 15px;
                    line-height: 16px;
                }
            }

            .report-filter-dropdown-menu-content-container {
                height: 280px;
                width: 252px;
                padding: 10px 15px;

                .report-filter-dropdown-content-container {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    .report-filter-selectors-container {
                        display: flex;
                        flex-direction: column;
                        gap: 15px;

                        
                    }
                }
            }
        }
    }
`